import { render, staticRenderFns } from "./RoutinesImpact.vue?vue&type=template&id=7c8d5964"
import script from "./RoutinesImpact.vue?vue&type=script&lang=js"
export * from "./RoutinesImpact.vue?vue&type=script&lang=js"
import style0 from "./RoutinesImpact.vue?vue&type=style&index=0&id=7c8d5964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports